import { Link, NavLink } from "react-router-dom";

// Public brand header — solid black bar, white lockup, as on sparkcoaching.com.au
export const BrandHeader = ({ links = [] }) => (
  <header data-testid="brand-header" className="sticky top-0 z-50 bg-black text-white" style={{ borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
    <div className="spark-container flex items-center justify-between h-[72px] sm:h-20">
      <Link to="/" data-testid="brand-home-link" className="flex items-center" aria-label="Spark Coaching — home">
        <img src="/brand/lockup_white.png" alt="Spark Coaching" className="h-9 sm:h-11 w-auto" />
      </Link>
      <nav className="hidden md:flex items-center gap-8 text-sm">
        {links.map(l => (
          l.href
            ? <a key={l.label} href={l.href} data-testid={`header-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`} className="opacity-80 hover:opacity-100 transition-opacity">{l.label}</a>
            : <NavLink key={l.label} to={l.to} data-testid={`header-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`} className="opacity-80 hover:opacity-100 transition-opacity">{l.label}</NavLink>
        ))}
      </nav>
      <Link to="/signin" data-testid="header-signin-btn" className="spark-btn-outline-light">Sign in</Link>
    </div>
  </header>
);

export default BrandHeader;
